export default __webpack_public_path__ + "static/media/expand-more.86b21818.svg";